import React from 'react';
import Footer from './Footer.js';
import './clientservice.css';

function ClientService() {
  return (
    <>
      <div className="cs-container">
        <div className="cs-content">
          <span className="cs-icon">🚧</span>
          <h1 className="cs-title">Page Under Construction</h1>
          <p className="cs-desc">We're working hard to bring you our Client Services portal. Please check back soon.</p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ClientService;
